import { createFileRoute } from '@tanstack/react-router';
import {
  OAuthCallbackFailed,
  completeOAuthCallback,
  oauthCallbackSearch,
  requireOAuthCallbackAccess,
} from '@/components/integrations-hub/oauth-callback';

// Salesforce redirects here with ?code&state (the callback URL on the External Client App).
export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/salesforce/callback',
)({
  validateSearch: oauthCallbackSearch,
  beforeLoad: ({ context }) => requireOAuthCallbackAccess(context),
  loaderDeps: ({ search }) => search,
  loader: ({ deps, context }) =>
    completeOAuthCallback('salesforce', deps, context.queryClient),
  component: SalesforceCallbackPage,
});

function SalesforceCallbackPage() {
  const { failedReason } = Route.useLoaderData();
  return (
    <OAuthCallbackFailed
      integrationId="salesforce"
      failedReason={failedReason}
    />
  );
}
